import {useCallback, useEffect, useState} from "react";
import {getbackSideCardImage, getCard, getCardImage, getPublicBackSideCardImage, getPublicCard, getPublicCardImage} from "@/api/card";
import globalStyle from '@/styles/Global.scss'

const ImageCard = ({id, isPublic = false, onClick = () => {}}) => {
  const [data, setData] = useState('')
  const [backSideData, setBackSideData] = useState('')

  const fetchImage = useCallback(async () => {
    const card = isPublic ? await getPublicCard({id}) : await getCard({id})
    const data = isPublic ? await getPublicCardImage({id}) : await getCardImage({id})
    const base64ImageString = await data.text()
    setData(`data:${card.mime};base64,${base64ImageString}`)

    if (!card.backSideImageFile) {
      return
    }
    const backSideData = isPublic ? await getPublicBackSideCardImage({id}) : await getbackSideCardImage({id})
    if (backSideData) {
      const base64backSideImageString = await backSideData.text()
      setBackSideData(`data:${card.mime};base64,${base64backSideImageString}`)
    }
  }, [id, isPublic]);

  useEffect(() => {
    fetchImage()
  }, [fetchImage])

  return (
    <>
      {
        data !== '' &&
        <>
          <div>表面</div>
          <img alt={''} src={data} onClick={onClick} className={globalStyle.cardImage} />
        </>
      }
      {
        backSideData !== '' &&
        <>
          <div>裏面</div>
          <img alt={''} src={backSideData} onClick={onClick} className={globalStyle.cardImage}/>
        </>
      }
    </>
  )
}
export default ImageCard
